import { IMember } from '@cloudike/web_photos/dist/types/intarfaces/IMember'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from "shared/config/store"

import { familyMembersSelector } from '../../../team/model/selectors/teamSelectors'

import { selectAiBotAvatarPath } from './appSelectors'

const getAvatarUrl = (member: IMember) => member && member?._links?.avatar?.href || ''

export const selectNotifications = (state: RootState) => state.notifications.notifications

export const selectNotificationsLoading = (state: RootState) => state.notifications.loading

export const selectCurrentFileData = (state: RootState) => state.notifications.currentFileData

export const selectIsFileDataLoading = (state: RootState) => state.notifications.isFileDataLoading

export const selectCurrentCommentData = (state: RootState) => state.notifications.currentCommentData

export const selectCurrentReplyCommentData = (state: RootState) => state.notifications.currentReplyCommentData

export const selectIsNotificationsPopoverOpened = (state: RootState) => state.notifications.isNotificationsPopoverOpened

export const selectCurrentActiveNotification = (state: RootState) => state.notifications.currentActiveNotification

export const selectNotificationPreviewError = (state: RootState) => state.notifications.previewError

export const selectNotificationsWithAvatars = createSelector(
  selectNotifications,
  familyMembersSelector,
  selectAiBotAvatarPath,
  (notifications, familyMembers, aiBotAvatarPath) => {
    return notifications.map((notification) => {
      let avatarUrl: string

      if(notification.initiator_id <= 0) {
        avatarUrl = aiBotAvatarPath
      } else {
        const member = familyMembers.find((member) => Number(member.id) === Number(notification.initiator_id))
        avatarUrl = getAvatarUrl(member)
      }
      return {
        ...notification,
        avatarUrl,
      }

    })
  }
)
